export const SEARCH_TYPES = [
  'explore',
  'vehicle',
  'dealer',
  'market',
]


export const DEFAULT_SEARCH_TYPE = 'explore'
